@if (this.reviewForm) {
<app-review-form [title]="this.title" [id]="this.id" [readOnly]="this.readOnly" [status]="this.status">
  @for (section of this.reviewForm.sections; track section.id) {
  <app-review-form-section [label]="section?.label ?? ''" [readOnly]="this.readOnly">
    @for (lineItem of section?.lineItems; track lineItem.id) {
    <app-review-form-line-item [lineItem]="lineItem"></app-review-form-line-item>
    }
  </app-review-form-section>
  }
</app-review-form>
}
